import React, {Fragment, PureComponent} from 'react';
import logo from '../../../../assets/O-Silver-Partner-clr.png'

import './Title.css';

class Title extends PureComponent {
  render() {
    return (
      <Fragment>
        <div className="leedium__title-container">
          <h1 className={'leedium__title'}>{'LEEDIUM'}</h1>
        </div>
        <div className={'leedium__info-container'}>
          <div className={'leedium__quote-container'}>
            <ul><li>Advise</li><li>Build</li><li>Test</li><li>Optimize</li></ul>
          </div>
          <ul>
            <li>
              <div>Ecommerce Solutions Consulting</div>
              <ul>
                <li>Custom storefront experiences<br/>(Products, Customer, Basket)</li>
                <li>Secure payment provider gateway integrations</li>
                <li>Sitewide performance / optimization &amp; repairs</li>
                <li>Surgical legacy code transplants</li>
                <li>Data-model transformations</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              <div>Frontend Development</div>
              <ul>
                <li>UI / Component Architecture<br/>(Modular / Reusable / Bundling)</li>
                <li>Reactive / Bindable Frameworks
                  <ul>
                    <li>React / Redux </li>
                    <li>Angular</li>
                    <li>Vue</li>
                    <li>Knockout</li></ul>
                </li>
                <li>CSS / BEM / Bootstrap / greensock</li>
                <li>UI motion &amp; animation design</li>
                <li>Webpack / Gulp / Grunt</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              <div>Backend Development</div>
              <ul>
                <li>Server Extensions, Web Services</li>
                <li>Node JS / Express / Koa</li>
                <li>Redis / MongoDB</li>
                <li>Web Sockets</li>
              </ul>
            </li>
          </ul>

        </div>
        <ul className={'leedium__contact'}>
          <li className="leedium__contact__social">
            <a target={'_blank'} href={'https://github.com/leedium'}><br/><svg width="24" height="24" aria-labelledby="simpleicons-github-icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title id="simpleicons-github-icon">GitHub icon</title><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg></a>
            <a target={'_blank'} href={'https://www.linkedin.com/in/leedium/'}><br/><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0v24h24v-24h-24zm8 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.397-2.586 7-2.777 7 2.476v6.759z"/></svg></a>
          </li>
          <li><img alt="Oracle Silver Partner" className="leedium__contact__logo" src={logo} /> </li>
        </ul>
      </Fragment>
    )
  }
}

export default Title





// WEBPACK FOOTER //
// ./src/js/common/components/Title/Title.jsx